// extracted by mini-css-extract-plugin
module.exports = {"skeletonTable":"styles_skeletonTable__m0I-f","skeleton":"styles_skeleton__2g77p"};